import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=4a0aeb2e&scoped=true"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"
import style0 from "./DashboardCharts.vue?vue&type=style&index=0&id=4a0aeb2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0aeb2e",
  null
  
)

export default component.exports